module.exports = __webpack_public_path__ + "img/pen-fill.d34063e8.svg";